/**
 * Navigation manifest (CD-12: config-driven, not a hardcoded component list).
 * NavRail renders from this array; adding a screen = adding a row here plus its
 * route in App.jsx. `color` is the domain's accent — an ACTIVE-STATE SIGNAL ONLY
 * (the rail is monochrome grey otherwise), and a token var so it theme-switches.
 * `icon` is the design's Material Symbols Rounded glyph name, verbatim.
 * `planned` marks a domain that is a future enhancement: the rail dims it, the
 * shell greys the screen and says so, but the link still works.
 */

export interface NavItem {
  id: string
  label: string
  path: string
  /** Prefix that marks the item active, when it differs from `path`. */
  match?: string
  icon: string
  color: string
  /** True for a domain that is not developed yet. The rail and the screen grey out. */
  planned?: boolean
}

export const NAV_ITEMS: readonly NavItem[] = [
  { id: 'overview', label: 'Overview', path: '/', icon: 'grid_view', color: 'var(--brand)' },
  { id: 'analytics', label: 'Analytics', path: '/analytics', icon: 'monitoring', color: 'var(--blue)', planned: true },
  { id: 'margin', label: 'Margin', path: '/margin', icon: 'payments', color: 'var(--green)' },
  { id: 'capacity', label: 'Capacity', path: '/capacity', icon: 'precision_manufacturing', color: 'var(--cyan)' },
  { id: 'orderbook', label: 'Order Book', path: '/order-book', icon: 'receipt_long', color: 'var(--orange)', planned: true },
  {
    id: 'delivery',
    label: 'Delivery & Quality',
    path: '/delivery',
    icon: 'local_shipping',
    color: 'var(--purple)',
    planned: true,
  },
  { id: 'recon', label: 'Reconciliation', path: '/reconciliation', icon: 'balance', color: 'var(--pink)', planned: true },
  {
    id: 'governance',
    label: 'Governance',
    path: '/governance/definitions',
    match: '/governance',
    icon: 'gavel',
    color: 'var(--neutral)',
  },
  { id: 'intelligence', label: 'Intelligence', path: '/intelligence', icon: 'neurology', color: '#fbbf24', planned: true },
]

/** Active = exact match for the root, prefix match otherwise. */
export function isNavActive(pathname: string, item: NavItem): boolean {
  const prefix = item.match ?? item.path
  return prefix === '/' ? pathname === '/' : pathname.startsWith(prefix)
}
